import { render, staticRenderFns } from "./toolbar.vue?vue&type=template&id=853fc66c&scoped=true&"
import script from "./toolbar.vue?vue&type=script&lang=js&"
export * from "./toolbar.vue?vue&type=script&lang=js&"
import style0 from "./toolbar.vue?vue&type=style&index=0&id=853fc66c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853fc66c",
  null
  
)

export default component.exports